import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: auto;

    hr.solid {
    border-top: 1px solid #bbb;
    width: 85%;
    margin-top: 20px;
  }

  @media(max-width: 800px) {
    width: 100vw;
  }

  .span-contact {
    width: 400px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    margin-bottom: 30px;

    @media(max-width: 800px) {
      font-size: 16px;
      text-align: center;
      width: 350px;
    }
  }

  span {
    font-size: 18px;
  }

  .container-submit {
    width: 500px;
    height: 60px;
    display: flex;
    margin: auto;
    justify-content: center;
    flex-direction: column;
    margin-top: 20px;
    margin-bottom: 40px;
    
    @media(max-width: 800px) {
      width: 100vw;
    }
  }

  .btn-send {
    font-size: 2%;
    width: 120px;
    height: 42px;
    border: none;
    background-color: black;
    color: white;
    margin: auto;
    cursor: pointer;
    letter-spacing: 1px;
      :hover{
        background-color: white;
        color: black;
        border: 1px solid black;
      }
      :disabled{
        background-color: #D6D6D6;
        color: black;
        cursor: not-allowed;
      }

      @media(max-width: 800px) {
        width: 90vw;
        margin: auto;
        margin-top: 20px;
      }
  }
`

export const Title = styled.div`
  text-align: center;
  font-size: 28px;
  margin-top: 20px;
  font-weight: bold;
`

export const ContainerForm = styled.div`
  width: 70%;
  height: auto;
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: 20px;

  @media(max-width: 800px) {
    width: 100vw;
    margin: 0;
  }
`

export const Items = styled.div`
  width: 70%;
  height: auto;
  display: flex;
  justify-content: center;

  @media(max-width: 800px) {
    width: 100vw;
  }

  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    content: none;
  }

  .ant-form {
    @media(max-width: 800px) {
      width: 100vw;
    }
  }

  .label {
    width: 580px;
    font-size: 14px;
    margin: auto;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    font-weight: bold;

    @media(max-width: 800px) {
      width: 90vw;
      margin-left: 20px;
      align-items: center;
      flex-direction: row;
    }
  }

  .required {
      label::after {
      content: "*";
      color: red;
    }
  }

  .input {
    width: 580px;
    height: 25px;
    color: #808080;
    padding: 0;
    border: none;
    border-bottom: 1px solid;
    border-radius: 0px;
    border-color: #3C3C3B;

    @media(max-width: 800px) {
      width: 90vw;
    }
  }

  .ant-input:focus {
    border-right-width: 1px !important;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  textarea {
    width: 580px;
    max-height: 80px;
    overflow-y: scroll;
    border: none;
    border-bottom: 1px solid;
    padding: 0;
    border-radius: 0px;
    border-color: #3C3C3B;
    font-family: "Roboto",sans-serif;
    &:hover, :focus{
      border-color: black;
    }

    @media(max-width: 800px) {
      width: 90vw;
    }
  }
`

export const ContainerContacts = styled.div`
  width: 300px;
  height: 150px;
  display: flex;
  flex-direction: column;
  margin-left: 40px;

  @media(max-width: 800px) {
    width: 90vw;
    height: 150px;
    margin-left: 2rem;
  }

  span {
    font-size: 16px;
    height: 25px;
  }

  .contact-email {
    width: 250px;
    height: 30px;
    display: flex;
  }

  .icon-email {
    width: 20px;
    height: 20px;
  }

  .href-email {
    margin-left: 10px;
    color: black;
    font-size: 15px;
    letter-spacing: 0.5px;
    text-decoration: none;
  }

  .icon-whatsapp{
    width: 20px;
    height: 20px;
  }

  .contact-whatsapp {
    width: 250px;
    height: 20px;
    display: flex;
    align-items: center;
  }

  .whatsapp {
    height: 20px;
    margin-left: 10px;
    color: black;
    font-size: 15px;
    letter-spacing: 0.5px;
    margin-top: 10px;
  }

  .schedule {
    width: 250px;
    height: 40px;
    margin-top: 20px;
  }
`

export const Terms = styled.div`
  width: 650px;
  padding: 0 20px;
  margin: auto;

  @media(max-width: 800px) {
    width: 100vw;
    padding: 0;
  }
`

export const Authorizations = styled.div`
  width: 570px;
  height: auto;
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-bottom: 20px;

  @media(min-width: 1920px) {
    width: 90%;
    margin: auto;
  }

  @media(max-width: 800px) {
    width: 90vw;
  }

  input:focus, input:focus-visible {
    border: 0;
    outline: none;
  }

  input[type='checkbox']::before {
    content: ' ';
    width: 25px;
    height: 25px;
    position: absolute;
    background-color: #ECECEC;
    border-radius: 30px;
    border: 2px solid black;
    margin: -6px 0 0 -5px;
  }
input[type='checkbox']:checked::after {
  content: '';
  border-color: black;
  border-style: solid;
  border-width: 11px 11px 11px 11px;
  position: absolute;
  margin-left: -3px;
  margin-top: -4px;
  border-radius: 50%;
  display: inline-block;
}

  span {
    margin-left: 25px;
    width: 100%;
    font-size: 15px;
    font-weight: bold;
  }

  .required-term::after{
    content: "*";
    color: red;
  }

  .container-checkbox {
    display: flex;
    margin-top: 20px;
    width: 100%;
    height: auto;
    margin-bottom: 10px;
    font-size: 15px;
    align-items: center;

    @media(max-width: 800px) {
      max-width: 100vw; 
    }
  }

  p {
    color: red;
    font-size: 15px;
  }
`

export const ModalTerm = styled.div`
  width: 570px;
  height: 40px;
  margin: auto;
  cursor: pointer;

  @media(max-width: 800px) {
    height: 80px;
    width: 85vw;
    margin: auto;
    margin-top: 20px;
  }
`